interface WordBoxProps {
    words: string[];
}

const WordBox = (props: WordBoxProps) => {
    const filteredWords = props.words.filter((word) => word.trim());
    if (!filteredWords.length) return null;

    return (
        <div className="bg-white border border-p6-grey-light rounded-medium p-s flex flex-wrap justify-around gap-s">
            {filteredWords.map((word, index) => (
                <span key={`${word}-${index}`} className="text-m font-semibold text-p6-grey-dark">
                    {word}
                </span>
            ))}
        </div>
    );
};

export default WordBox;
